import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "antd";
import "../../Forms/Form.css";
import "../../../Components/Commons/Commons.css";
import TextArea from "../../Commons/Forms/TextArea";
import { Container } from "react-bootstrap";
import { formatDate } from "../../../Assets/Helpers/Common";
import BtnPrint from "../../Commons/Buttons/BtnPrint"
import {
  getMedicalAbstract,
} from "../../Helpers/API/PatientApi/FormApi"
import { Checkbox, Divider } from "antd";
import FormFooter from "../../Commons/Table/FormFooter";
import FormHeader from "../../Commons/FormHeader";
import BtnPrintV2 from "../../Commons/Buttons/BtnPrintV2";

function MedicalAbstract({ id, fileName }) {
  const abstractRef = useRef() 
  const [diagnosisLabels, setDiagnosisLabels] = useState([])
  const [therapeuticsLabels, setTherapeuticsLabels] = useState([])
  const [addDetails, setAddDetails] = useState({
    patient_id: id,
    form_template_id: 6,
  })
  const currentDate = new Date()
  const [formDetails, setFormDetails] = useState(false)


  // Function for handling the value for therapeutics and diagnostics input fields
  const handleOnChange = (checkedValues, name) => {
    setAddDetails((prevState) => ({
      ...prevState,
      [name]: checkedValues,
    }))
  }

  // Function for handling the value to input fields
  const handleAddChange = (e) => {
    const { name, value } = e.target
    setAddDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  // Function save form API
  // const handleSaveForm = async () => {
  //   setIsClicked(true)
  //   const res = await saveForm(addDetails)
  //   if (res.data) {
  //     toast.success(res.data.message)
  //     if (formPdf) {
  //       await handleUploadFile(res.data.form_id)
  //     }
  //     // fetchForm();
  //   } else if (res.error) {
  //   }
  //   setFormPdf(null)
  //   setIsClicked(false)
  // }

  // UPLOAD FILE TO PATIENT ATTACHMENTS
  // async function handleUploadFile(formId) {
  //   const response = await createFormAttachment(
  //     id,
  //     [{ file: formPdf }],
  //     "Medical Abstract",
  //     formId, //form id
  //     "6" //form template id
  //   )
  //   if (response.error) {
  //     response.error?.data?.messages.map((data) => {
  //       return toast.error(data)
  //     })
  //   } else {
  //     toast.success(response.data.message, { autoClose: 1000 })
  //   }
  // }

  // Function medical abstract API
  async function fetchForm() {
    const res = await getMedicalAbstract({
      patient_id: id,
    })

    if (res.data) {
      var diagnosisOptions = res.data.data.diagnosis
        .filter((d) => d && d.diagnosis_name !== null && d.diagnosis_name !== undefined)
        .map((d) => ({
          value: d.diagnosis_name,
          label: d.diagnosis_name,
        }))

      var therapeuticsOptions = res.data.data.therapeutics.map((p) => ({
        value: `{"therapeutic_id": "${p.id}", "therapeutic_name": "${
          p?.generic || ""
        } ${p?.brand || ""} - ${p?.dosage || ""} ${p?.quantity || ""} ${
          p?.form || ""
        } ${p?.preparation || ""}"}`,
        label: `${p?.generic || ""} ${p?.brand || ""} - ${p?.dosage || ""} ${
          p?.quantity || ""
        } ${p?.form || ""} ${p?.preparation || ""}`,
      }))
      setFormDetails(() => ({
        patient: res.data.data.patient ?? [],
        diagnosisOptions,
        therapeuticsOptions,
      }))
      setDiagnosisLabels(diagnosisOptions)
      setTherapeuticsLabels(therapeuticsOptions)
    } else if (res.error) {
    }
  }

  useEffect(() => {
    fetchForm()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // useEffect(() => {
  //   if (formPdf) {
  //     handleSaveForm()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [formPdf])

  return (
    <div>
      <div className="col">
        <div className="row p-3">
          <div className="col font-large font-bold">MEDICAL ABSTRACT</div>
        </div>
        <div className="row pl-4">
          <div className="row mt-2">
            <div className="col">
              <p className="p-1 form-label align-left">DIAGNOSIS</p>
                <Checkbox.Group
                  className="grid-abstract"
                  options={diagnosisLabels}
                  onChange={(checkedValues) =>
                    handleOnChange(checkedValues, "diagnosis")
                  }
                />
              <p className="mt-4 p-1 form-label align-left">THERAPEUTICS</p>
              <Checkbox.Group
                className="grid-abstract"
                options={therapeuticsLabels}
                onChange={(checkedValues) =>
                  handleOnChange(checkedValues, "therapeutics")
                }
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col">
              <TextArea
                required
                id="name"
                formLabel={`PLAN`}
                size={`sm`}
                placeholder={``}
                onChange={(e) => handleAddChange(e)}
                name="plan"
                errorMessage="This is an error"
              />
            </div>
          </div>
        </div>
      </div>
      <Divider />

      <Container className="">
        <div id={"print_abstract"} className="">
          <div className="print-area dotted rounded px-5" id={`medical_abstract_${id}`} ref={abstractRef}>
            <div className="form-padding">
              {/* <FormHeader/> */}
              <Row className="rx-header">
                <Col span={24}>
                  <FormHeader/>
                </Col>
              </Row>
              <div className="row d-flex justify-content-center text-center">
                <label>
                  <strong style={{ fontSize: "30px" }}>Medical Abstract</strong>
                </label>
              </div>
              <div className="row pt-5 d-flex justify-content-center text-right">
                <div className="row">
                  <label>
                    <span>{formatDate(currentDate)}</span>
                  </label>
                </div>
              </div>
              <div className="row pt-4 d-flex justify-content-center text-left">
                <div className="row">
                  {formDetails?.patient && (
                    <div className="col">
                      <label>
                        <span>This is a case of</span>
                        <strong> {formDetails?.patient[0]?.formatted_patient_name} </strong>,
                        <span>
                          {" "}
                          {formDetails?.patient[0]?.age}/{" "}
                          {formDetails?.patient[0]?.sex},
                        </span>
                      </label>
                    </div>
                  )}
                </div>
              </div>
              {addDetails.diagnosis?.length > 0 && (
                <div className="row pt-5 d-flex justify-content-center text-left">
                  <div className="row">
                    <label>
                      <h5>
                        <strong>DIAGNOSIS</strong>
                      </h5>
                    </label>
                  </div>
                  <div>
                    <ul>
                      {addDetails.diagnosis?.map((d) => (
                        <li>{d}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
              {addDetails.therapeutics?.length > 0 && (
                <div className="row pt-5 d-flex justify-content-center text-left">
                  <div className="row">
                    <label>
                      <h5>
                        <strong>THERAPEUTICS</strong>
                      </h5>
                    </label>
                  </div>
                  <div>
                    <ul>
                      {addDetails.therapeutics?.map((t) => {
                        var therapeutic = JSON.parse(t)
                        return <li>{therapeutic.therapeutic_name}</li>
                      })}
                    </ul>
                  </div>
                </div>
              )}
              <div className="row pt-5 d-flex justify-content-center text-left">
                <div className="row">
                  <label>
                    <h5>
                      <strong>PLAN</strong>
                    </h5>
                  </label>
                </div>
                <div className="row">
                  <label>{addDetails.plan}</label>
                </div>
              </div>
              <FormFooter/>
            </div>
          </div>
        </div>
        {(addDetails?.plan && addDetails?.plan !== "") && (
          <>
            <div className="row justify-content-end mt-5 ">
              <div className="col-5">
                {/* <BtnPrint
                  label={"Save Form"}
                  size={"xl"}
                  // divId={`medical_abstract_${id}`}
                  divId={abstractRef}
                  fileName={fileName}
                /> */}
                <BtnPrintV2
                  label={"Save Form"}
                  size={"xl"}
                  divId={abstractRef}
                  fileName={fileName}
                  paperType={"a4"}
                />
              </div>
            </div>
          </>
        )}
      </Container>
    </div>
  )
}
export default MedicalAbstract;
